import React, { useState, useEffect } from "react";
import {
  Button,
  FormControl,
  FormLabel,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
  Typography,
  Avatar,
  IconButton,
  RadioGroup,
  Radio,
  FormControlLabel,
} from "@material-ui/core";
import InputLabel from "@material-ui/core/InputLabel";
import useStyles from "../../../../styles";
import axios from "axios";
import { decryptData } from "../../../../crypto";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import ReactQuill from "react-quill";
import AddBoxOutlinedIcon from "@material-ui/icons/AddBoxOutlined";
import IndeterminateCheckBoxOutlinedIcon from "@material-ui/icons/IndeterminateCheckBoxOutlined";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Matrix from "./Matrix";
import QuestionSection from "./QuestionSection";
import TestCaseSection from "./TestCaseSection ";

function AddCodingQuestion({
  changeTab,
  examDetails,
  questionsLength,
  quillFormats,
  quillModules,
  personName,
  setQuillContentEnglishDescription,
  setQuillContentHindiDescription,
  quillContentEnglishDescription,
  quillContentHindiDescription,
  setQuillContentEnglishQuestion,
  setQuillContentHindiQuestion,
  quillContentEnglishQuestion,
  quillContentHindiQuestion,
  formDetails,
  setFormDetails,
  handleSubmit,
  handleClose,
  loading,
  topics,
  question,
  setQuestion,
  sections
}) {
  const classes = useStyles();

  const codingLanguages = [
    {
      language: "C",
      template: `#include <stdio.h>

int main() {
    // Write your code here
    
    
    
    return 0;
}`,
    },

    {
      language: "C++",
      template: `#include <iostream>
using namespace std;

int main() {
    // Write your code here
    
    
    
    return 0;
}`,
    },

    {
      language: "Java Script",
      template: `'use strict';

function main() {
    // Write your code here
    
    
    
}

main();`,
    },

    {
      language: "Python",
      template: `def main():
    # Write your code here
    
    
    
if __name__ == "__main__":
    main()`,
    },

    {
      language: "Java",
      template: `import java.util.*;

public class Main {
    public static void main(String[] args) {
        // Write your code here
        
        
        
    }
}`,
    },
  ];

  // const [question, setQuestion] = useState("coding");

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormDetails((prevDetails) => ({
      ...prevDetails,
      [name]: value,
    }));
  };
  const handleChangeCoding = (event, newValue) => {
    setFormDetails((prevDetails) => ({
      ...prevDetails,
      code_language: newValue,
    }));
  };

  const menuProps = {
    getContentAnchorEl: null,
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "left",
    },
    disablePortal: true,
  };

  useEffect(() => {
    console.log("formDetailsformDetails", formDetails);
  }, [formDetails]);

  return (
    <div
      className={`${classes.mt1}  ${classes.inputpadding} ${classes.inputborder} ${classes.pagescroll} ${classes.h60vh}`}
    >
      <FormControl className={`${classes.w100}`}>
        <div
          className={`${classes.bgwhite} ${classes.boxshadow3} ${classes.borderradius6px} ${classes.py2} ${classes.px1_5} ${classes.mt1}`}
        >
          <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
            <Typography
              className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
              variant="h6"
              display="inline"
            >
              *Create Question
            </Typography>
            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24} ${classes.mb1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
              >
                Question <span className={classes.textcolorred}>*</span>
              </FormLabel>
              <RadioGroup
                className={`${classes.radiocolor}`}
                row
                aria-label="question"
                name="question"
                value={question}
                onChange={handleChange}
              >
                <FormControlLabel
                  value="normal"
                  control={<Radio onClick={() => setQuestion("normal")} />}
                  label="Normal"
                />
                <FormControlLabel
                  value="paragraph"
                  control={<Radio onClick={() => setQuestion("paragraph")} />}
                  label="Paragraph"
                />
                <FormControlLabel
                  value="typing"
                  control={<Radio onClick={() => setQuestion("typing")} />}
                  label="Typing"
                />
                <FormControlLabel
                  value="coding"
                  control={<Radio onClick={() => setQuestion("coding")} />}
                  label="Coding"
                />
              </RadioGroup>
            </div>
            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24} ${classes.mb1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
              >
                Hardness Level
              </FormLabel>

              <Select
                labelId="category-label"
                id="state"
                value={formDetails.hardnesslevel}
                name="hardnesslevel"
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                MenuProps={menuProps}
                variant="outlined"
                disabled={question === "typing"}
              >
                <MenuItem disabled value="">
                  <em className={classes.defaultselect}>Select Here</em>
                </MenuItem>
                <MenuItem value={"easy"}>Easy</MenuItem>
                <MenuItem value={"medium"}>Medium</MenuItem>
                <MenuItem value={"hard"}>Hard</MenuItem>
                <MenuItem value={"expert"}>Expert</MenuItem>
              </Select>
            </div>
            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
              >
                Question Number
              </FormLabel>
              <TextField
                type="number"
                variant="outlined"
                name="q_prifix"
                onChange={handleChange}
                value={formDetails.q_prifix}
                placeholder="Type Here"
                onWheel={(e) => e.target.blur()}
              />
            </div>
          </div>

          <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
            <Typography
              className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
              variant="h6"
              display="inline"
            ></Typography>

            {examDetails.questionMarkSystem === "same" ? (
              <div
                className={`${classes.dflex} ${
                  classes.flexdirectioncolumn
                }  ${classes.w24}  ${classes.mb1}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Marks
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  name="marks"
                  onChange={handleChange}
                  value={formDetails.marks}
                  placeholder="Type Here"
                  disabled
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            ) : (
              <div
                className={`${classes.dflex} ${
                  classes.flexdirectioncolumn
                }  ${classes.w24} ${classes.mb1}`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                >
                  Marks
                </FormLabel>
                <TextField
                  type="number"
                  variant="outlined"
                  name="marks"
                  onChange={handleChange}
                  value={formDetails.marks}
                  placeholder="Type Here"
                  onWheel={(e) => e.target.blur()}
                />
              </div>
            )}
            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
                             ${classes.fw400} ${classes.lineheight}`}
              >
                Subject
              </FormLabel>
              <Select
                labelId="demo-simple-select-placeholder-label-label"
                id="demo-simple-select-placeholder-label"
                value={formDetails.topic}
                name="topic"
                onChange={handleChange}
                displayEmpty
                className={classes.selectEmpty}
                MenuProps={menuProps}
                variant="outlined"
              >
                <MenuItem disabled value="">
                  <em className={classes.defaultselect}>Select Subject</em>
                </MenuItem>
                {loading ? (
                  <MenuItem disabled value="">
                    Loading Subjects...
                  </MenuItem>
                ) : (
                  topics.map((topic) => (
                    <MenuItem key={topic.id} value={topic.id}>
                      {topic.subject_name}
                    </MenuItem>
                  ))
                )}
              </Select>
            </div>
            {examDetails.examTemplate === "ssc/railway" ||
            examDetails.examTemplate === "ipmat" ? (
              <div
                className={`${classes.dflex} ${
                  classes.flexdirectioncolumn
                }   ${question === "typing" ? classes.w37 : classes.w24} ${
                  classes.mb1
                }`}
              >
                <FormLabel
                  className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal}
                           ${classes.fw400} ${classes.lineheight}`}
                >
                  Sections
                </FormLabel>

                <Select
                  labelId="demo-simple-select-placeholder-label-label"
                  id="demo-simple-select-placeholder-label"
                  value={formDetails.section}
                  name="section"
                  onChange={handleChange}
                  displayEmpty
                  className={classes.selectEmpty}
                  MenuProps={menuProps}
                  variant="outlined"
                >
                  <MenuItem disabled value="">
                    <em className={classes.defaultselect}>Select Section</em>
                  </MenuItem>
                  {sections.map((section) => (
                    <MenuItem key={section.id} value={section.id}>
                      {section.section_name}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            ) : (
              <div
                className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24} ${classes.mb1}`}
              ></div>
            )}
          </div>

          <div className={`${classes.dflex} ${classes.justifyspacebetween} `}>
            <Typography
              className={`${classes.w24} ${classes.mb1} ${classes.textcolorformhead} ${classes.fontfamilyoutfit} ${classes.fontsize} ${classes.fontstylenormal} ${classes.fw500} ${classes.lineheight2_25}`}
              variant="h6"
              display="inline"
            ></Typography>
            <>
              {examDetails.questionMarkSystem === "same" ? (
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24} ${classes.mb1}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Negative Marking{" "}
                  </FormLabel>
                  <Select
                    labelId="negativemarking-label"
                    id="negativemarking"
                    value={formDetails.negative_marking}
                    name="negative_marking"
                    onChange={handleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    MenuProps={menuProps}
                    variant="outlined"
                    disabled
                  >
                    <MenuItem disabled value="">
                      <em className={classes.defaultselect}>Select Here</em>
                    </MenuItem>
                    <MenuItem value={"yes"}>Yes</MenuItem>
                    <MenuItem value={"no"}>No</MenuItem>
                  </Select>
                </div>
              ) : (
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn}  ${classes.w24} ${classes.mb1}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Negative Marking{" "}
                  </FormLabel>
                  <Select
                    labelId="negativemarking-label"
                    id="negativemarking"
                    value={formDetails.negative_marking}
                    name="negative_marking"
                    onChange={handleChange}
                    displayEmpty
                    className={classes.selectEmpty}
                    MenuProps={menuProps}
                    variant="outlined"
                  >
                    <MenuItem disabled value="">
                      <em className={classes.defaultselect}>Select Here</em>
                    </MenuItem>
                    <MenuItem value={"yes"}>Yes</MenuItem>
                    <MenuItem value={"no"}>No</MenuItem>
                  </Select>
                </div>
              )}
            </>
            <>
              {examDetails.questionMarkSystem === "same" ? (
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Negative Marking Score{" "}
                  </FormLabel>
                  <TextField
                    type="float"
                    variant="outlined"
                    required
                    name="negative_marking_score"
                    value={formDetails.negative_marking_score}
                    onChange={handleChange}
                    placeholder="Type Here"
                    disabled
                  />
                </div>
              ) : (
                <div
                  className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
                >
                  <FormLabel
                    className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
                  >
                    Negative Marking Score{" "}
                  </FormLabel>
                  <TextField
                    type="float"
                    variant="outlined"
                    required
                    name="negative_marking_score"
                    value={
                      formDetails.negative_marking === "yes"
                        ? `-${String(
                            formDetails.negative_marking_score,
                          ).replace(/^[-]+/, "")}`
                        : formDetails.negative_marking_score
                    }
                    onChange={(e) => {
                      let value = e.target.value.replace(/[^0-9.]/g, ""); // Allow only digits

                      if (formDetails.negative_marking === "yes") {
                        value = value ? `-${value}` : "";
                      }

                      handleChange({
                        target: {
                          name: "negative_marking_score",
                          value,
                        },
                      });
                    }}
                    // onChange={handleChange}
                    placeholder="Type Here"
                    disabled={formDetails.negative_marking === "no"}
                  />
                </div>
              )}
            </>
            <div
              className={`${classes.dflex} ${classes.flexdirectioncolumn} ${classes.w24} ${classes.mb1}`}
            >
              <FormLabel
                className={`${classes.textcolorformlabel} ${classes.fontfamilyoutfit}  ${classes.fontsize1} ${classes.fontstylenormal} ${classes.fw400} ${classes.lineheight}`}
              >
                Coding Languages <span className={classes.textcolorred}>*</span>
              </FormLabel>

              <Autocomplete
                multiple
                id="tags-standard"
                options={codingLanguages}
                getOptionLabel={(option) => option.language}
                value={formDetails?.code_language || []}
                onChange={handleChangeCoding}
                disableClearable
                forcePopupIcon={false}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="code_language"
                    variant="outlined"
                    placeholder="Type to pick..."
                  />
                )}
              />
            </div>
          </div>
        </div>
        <QuestionSection
          classes={classes}
          quillFormats={quillFormats}
          quillModules={quillModules}
          personName={personName}
          setQuillContentEnglishDescription={setQuillContentEnglishDescription}
          setQuillContentHindiDescription={setQuillContentHindiDescription}
          quillContentEnglishDescription={quillContentEnglishDescription}
          quillContentHindiDescription={quillContentHindiDescription}
          setQuillContentEnglishQuestion={setQuillContentEnglishQuestion}
          setQuillContentHindiQuestion={setQuillContentHindiQuestion}
          quillContentEnglishQuestion={quillContentEnglishQuestion}
          quillContentHindiQuestion={quillContentHindiQuestion}
          formDetails={formDetails}
          setFormDetails={setFormDetails}
        />
        <TestCaseSection
          classes={classes}
          formDetails={formDetails}
          setFormDetails={setFormDetails}
        />
        <div
          className={`${classes.dflex} ${classes.justifyflexend} ${classes.mt1}`}
        >
          <Button
            className={`${classes.custombtnoutline}`}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button className={`${classes.custombtnblue}`} onClick={handleSubmit}>
            Submit
          </Button>
        </div>
      </FormControl>
    </div>
  );
}

export default AddCodingQuestion;
